module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("TREACHEROUS"), _c('br'), _vm._v("ALLIANCE"), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("the secret dealings of"), _c('br'), _vm._v("Israel, Iran, and the"), _c('br'), _vm._v("United States"), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("trita parsi"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_vm._v("yale university press / new haven and london")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3998de53","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/02-titlepage.vue
// module id = 60
// module chunks = 0